// src/components/home/FinalCTASection.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FinalCTASection.css';

const FinalCTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="final-cta-section">
      <div className="section-container">
        {/* Main CTA Box */}
        <div className="cta-box">
          <div className="cta-badge">🎉 Limited Time Offer</div>
          <h2 className="cta-title">Try BookDentist.pro Free for 14 Days</h2>
          <p className="cta-subtitle">
            See how instant booking increases your appointment volume, reduces no-shows, and converts more planned treatment—with zero risk.
          </p>

          <div className="cta-features-quick">
            <div className="quick-feature">✓ No credit card required</div>
            <div className="quick-feature">✓ Setup in under 5 minutes</div>
            <div className="quick-feature">✓ Cancel anytime</div>
          </div>

          <div className="cta-buttons">
            <button 
              onClick={() => navigate('/register')} 
              className="btn-cta-primary"
            >
              Start Free 14-Day Trial
            </button>
            <button 
              onClick={() => navigate('/dentistjunobeach')} 
              className="btn-cta-secondary"
            >
              See Live Demo First
            </button>
          </div>

          <div className="cta-pricing">
            <strong>Only $197/month</strong> after trial • HIPAA Compliant • Cancel Anytime
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h3 className="faq-title">Frequently Asked Questions</h3>
          
          <div className="faq-grid">
            <div className="faq-item">
              <div className="faq-question">How long does setup take?</div>
              <div className="faq-answer">
                Most practices are live in under 5 minutes. You just connect your Open Dental database (we provide simple instructions), customize your booking page, and you're done. No software to install, no Chrome extensions, no IT help needed.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">Do I really need to install software on my server?</div>
              <div className="faq-answer">
                No! That's the point. NexHealth and Weave require you to install software that constantly syncs. We connect directly to Open Dental's API—nothing to install, nothing to maintain.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">What if a patient books the wrong procedure?</div>
              <div className="faq-answer">
                Patients can only book appointments that match what's already planned in Open Dental. If Dr. Smith planned a crown, they can only book "Crown Preparation." They can't book a cleaning or root canal—the system won't let them.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">Can I control which time slots are available?</div>
              <div className="faq-answer">
                Yes. You set your booking rules in Open Dental (operatories, providers, hours, blocks), and BookDentist.pro respects them all. If you block 3:00 PM in Open Dental, patients can't book it online. Changes sync instantly.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">Is this HIPAA compliant?</div>
              <div className="faq-answer">
                Yes. We're fully HIPAA compliant, use encrypted connections, and never store patient health information. We only store what's needed for booking (name, contact info, appointment details).
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">What happens after the 14-day trial?</div>
              <div className="faq-answer">
                If you love it, you're automatically billed $197/month. If not, cancel anytime with one click—no questions asked, no hassle. We're confident you'll see the value in the first week.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">Can patients reschedule appointments?</div>
              <div className="faq-answer">
                Yes! Patients get a link in their confirmation email/SMS where they can reschedule or cancel (within your rules). This saves your front desk hours of phone calls every week.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">What about emergency appointments?</div>
              <div className="faq-answer">
                You control what types of appointments are available for online booking. Most practices only allow planned appointments and routine cleanings online. Emergency slots stay phone-only.
              </div>
            </div>
          </div>
        </div>

        {/* Final Push */}
        <div className="final-push">
          <div className="push-content">
            <h3 className="push-title">Here's What You Get Today:</h3>
            <ul className="push-list">
              <li>✓ Instant Open Dental integration (no software installation)</li>
              <li>✓ 24/7 online booking for your patients</li>
              <li>✓ Automatic planned appointment reminders & booking</li>
              <li>✓ Real-time sync (no 2-5 minute delays)</li>
              <li>✓ Mobile-friendly booking page</li>
              <li>✓ Email & SMS confirmations</li>
              <li>✓ HIPAA-compliant infrastructure</li>
              <li>✓ Email support</li>
            </ul>
            <div className="push-cta">
              <button 
                onClick={() => navigate('/register')} 
                className="btn-push"
              >
                Start Your Free 14-Day Trial Now
              </button>
              <div className="push-guarantee">
                No credit card required • Setup in 5 minutes • Cancel anytime
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;